import { CreateRoleAssignmentItem, RoleAssignmentSummary, UpdateExpirationRequest } from 'src/stores/role-assignments-store';
import DataStoreMock from './base/data-store';
import FormStoreMock from './base/form-store';
import { Query } from '@testing-library/react';
import { OrganizationRolesMockData } from '../data-sources/organization-roles';

export class RoleAssignmentSummaryStoreMock extends DataStoreMock<RoleAssignmentSummary> {
  public async load(_query: Partial<Query>) {
    this._state.set({
      isBusy: false,
      items: OrganizationRolesMockData,
      count: OrganizationRolesMockData.length,
    });
    return true;
  }

  public async loadStructmasterRoleAssignments(_query: Partial<Query>) {
    this._state.set({
      isBusy: false,
      items: OrganizationRolesMockData,
      count: OrganizationRolesMockData.length,
    });
    return true;
  }

  public async getRoles(query: Partial<Query>) {
    return OrganizationRolesMockData;
  }

  public async updateExpiration(id: string, item: UpdateExpirationRequest) {
    return { isSuccess: true, error: '', messages: [] };
  }

  public async updateExpirationInBulk(payload: { assignmentId: string; scopeId: string; newExpirationDate: Date }[]) {
    return { isSuccess: true, error: '', messages: [] };
  }

  public async loadLicenseAssignments(query: Partial<Query>) {
    this._state.set({
      isBusy: false,
      items: OrganizationRolesMockData,
      count: OrganizationRolesMockData.length,
    });
    return true;
  }

  public async deleteLicenseAssignment(id: string) {
    return { isSuccess: true, error: '', messages: [] };
  }
}

export class RoleAssignmentItemStoreMock extends FormStoreMock<RoleAssignmentSummary, CreateRoleAssignmentItem> {
  public async createStructMasterRoleAssignment(item: CreateRoleAssignmentItem) {
    return { isSuccess: true, error: '', messages: [] };
  }

  public async createLicenseRoleAssignment(item: CreateRoleAssignmentItem) {
    return { isSuccess: true, error: '', messages: [] };
  }
}
